import React from 'react';
import { Activity, Utensils, Pill, ChefHat, Moon, BookOpen } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    icon: <Activity className="w-8 h-8" data-id="element-298" />,
    title: 'TOMO 1 — EL DESPERTAR METABÓLICO',
    desc: 'Fundamentos y Hormonas. Por qué tu cuerpo cambió después de los 40, qué hormonas frenan tu metabolismo y el protocolo de reinicio de 7 días para activarlo desde adentro.'
  }, {
    icon: <Utensils className="w-8 h-8" data-id="element-299" />,
    title: 'TOMO 2 — PLAN ALIMENTARIO 21 DÍAS',
    desc: 'Comida Real Argentina. 21 días completos de desayuno, almuerzo, merienda y cena con ingredientes del supermercado argentino. Lista de compras semanal incluida.'
  }, {
    icon: <Pill className="w-8 h-8" data-id="element-300" />,
    title: 'TOMO 3 — SUPLEMENTACIÓN NATURAL Y CONTROL DE CORTISOL',
    desc: 'Tu Arsenal Hormonal. Los 7 suplementos estrella para mujeres 40+, protocolo de control de cortisol en 5 pasos y el protocolo de sueño reparador que activa la quema nocturna.'
  }, {
    icon: <ChefHat className="w-8 h-8" data-id="element-301" />,
    title: 'TOMO 4 — RECETARIO SIN HAMBRE',
    desc: 'Dulce y Salado. 50+ recetas rápidas (menos de 30 minutos), ricas y hormonalmente inteligentes. Todas con ingredientes de Coto, Carrefour o Jumbo.'
  }, {
    icon: <Moon className="w-8 h-8" data-id="element-302" />,
    title: 'TOMO 5 — PROTOCOLO DE AYUNO CONSCIENTE',
    desc: 'Para Mujeres 40+. 5 protocolos adaptados a tu etapa hormonal. Sin pasar hambre. Sin arruinar la tiroides. Sincronizado con tu ciclo si aún menstruás.'
  }, {
    icon: <BookOpen className="w-8 h-8" data-id="element-303" />,
    title: 'TOMO 6 — DIARIO DE TRANSFORMACIÓN',
    desc: 'Tracker de Medidas y Victorias. Sistema completo de seguimiento para 3 meses: medidas, hábitos, emociones, señales hormonales y plan de mantenimiento de por vida.'
  }];
  return <section className="bg-black text-white py-24 px-4" data-id="element-304">
      <div className="max-w-6xl mx-auto" data-id="element-305">
        <div className="text-center mb-16" data-id="element-306">
          <h2 className="font-display font-black text-5xl md:text-6xl mb-4 uppercase" data-id="element-307">
            SUPER COMBO PÉRDIDA DE PESO 40+
          </h2>
          <p className="text-2xl text-brand font-bold uppercase tracking-widest" data-id="element-308">
            6 Tomos Completos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-309">
          {tomos.map((tomo, i) => <div key={i} className="bg-zinc-900 border-t-4 border-brand rounded-b-xl p-8 hover:bg-zinc-800 transition-colors" data-id="element-310">
              <div className="w-16 h-16 bg-brand/10 text-brand rounded-xl flex items-center justify-center mb-6" data-id="element-311">
                {tomo.icon}
              </div>
              <h3 className="font-display font-bold text-xl mb-4 text-white" data-id="element-312">
                {tomo.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-313">{tomo.desc}</p>
            </div>)}
        </div>

        <div className="mt-16 bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-314">
          <h4 className="font-display font-bold text-2xl mb-6 text-brand" data-id="element-315">
            CADA TOMO INCLUYE:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4 text-left" data-id="element-316">
            <div className="flex items-center gap-3" data-id="element-317">
              <span className="text-brand" data-id="element-318">✅</span> Protocolo paso a paso listo
              para aplicar
            </div>
            <div className="flex items-center gap-3" data-id="element-319">
              <span className="text-brand" data-id="element-320">✅</span> Tablas y checklists
              imprimibles
            </div>
            <div className="flex items-center gap-3" data-id="element-321">
              <span className="text-brand" data-id="element-322">✅</span> Adaptado a la biología
              femenina 40+
            </div>
            <div className="flex items-center gap-3" data-id="element-323">
              <span className="text-brand" data-id="element-324">✅</span> Ingredientes disponibles en
              Argentina
            </div>
          </div>
        </div>
      </div>
    </section>;
}